//const theme_list = ["alpha", "aqua", "mist", "green", "retro", "pastel"];
const theme_list = [
  'alpha',
  'royal',
  'aqua',
  'mist',
  'retro',
  'pastel',
];
export default theme_list;
